<template>
	<div class="report-cls">
		<el-tabs v-model="activeName">
			<el-tab-pane label="文章点击" name="first">
				<ClickCom v-if="activeName === 'first'" />
			</el-tab-pane>
			<el-tab-pane label="关键词搜索" name="second">
				<Keyword v-if="activeName === 'second'" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import ClickCom from './click';
import Keyword from './keyword';

export default {
	components: {ClickCom, Keyword},
	data() {
		return {
			activeName: 'first',
		}
	}
}
</script>

<style lang="scss" scoped>
.report-cls {
	width: 100%;
	padding: 20px;
	box-sizing: border-box;
}
</style>